// NOTE: Create React App only inlines env vars prefixed with REACT_APP_, and only
// when they are written as literal `process.env.REACT_APP_X` member expressions.
// Do not refactor these into dynamic lookups.
//
// On Netlify, set these under Site settings -> Environment variables:
//   REACT_APP_SERVER_PROD_URL   e.g. https://api.legacytimepieces.com
//   REACT_APP_CLIENT_PROD_HOST  e.g. legacytimepieces.com
module.exports = {
  PORT: "3123",
  NODE_ENV: "staging",

  SERVER_DEV_URL: process.env.REACT_APP_SERVER_DEV_URL || "http://localhost:3123",
  SERVER_STAGING_URL: process.env.REACT_APP_SERVER_STAGING_URL || "",
  SERVER_PROD_URL: process.env.REACT_APP_SERVER_PROD_URL || "",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: process.env.REACT_APP_CLIENT_STAGING_URL || "",
  CLIENT_PROD_URL: process.env.REACT_APP_CLIENT_PROD_URL || "",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: process.env.REACT_APP_CLIENT_STAGING_HOST || "",
  CLIENT_PROD_HOST: process.env.REACT_APP_CLIENT_PROD_HOST || "",

  MAIN_WEBSITE_TITLE: "LEGACY TIMEPIECES | ",
  SITE_NAME: "Legacy Timepieces",
};
